import type { SvgIconProps } from "@mui/material";
import { styled } from "@mui/material";

import svg from "./candidate-objective-with-baseline-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

const CandidateObjectiveWithMinBaselineIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.grey[300],
);
const CandidateObjectiveWithMaxBaselineIcon = styled(
  CandidateObjectiveWithMinBaselineIcon,
)({
  transform: "scale(-1, 1)",
});

export function CandidateObjectiveWithBaselineIcon({
  objectiveType = "ScalarMax",
  ...props
}: SvgIconProps & { objectiveType?: "ScalarMax" | "ScalarMin" }) {
  return objectiveType === "ScalarMax" ? (
    <CandidateObjectiveWithMinBaselineIcon {...props} />
  ) : (
    <CandidateObjectiveWithMaxBaselineIcon {...props} />
  );
}

export default CandidateObjectiveWithBaselineIcon;
